import React from 'react';

import { useColumnPresetState } from '../../../pages/FinancialData/shared/ColumnPresetContext/ColumnPresetContext';
import { useTableGridApiDispatch } from '../TableGridApiContext/TableGridApiContext';
import { TableGridApiAction } from '../TableGridApiContext/TableGridApiContext.types';
import ColumnPresets, { ColumnPreset } from './ColumnPresets';

interface Props {
  systemDefaultFields: string[];
  systemDefaultPresets: ColumnPreset[];
  selectedColumns: string[];
}

const TableGridColumnPresetsToolbar: React.FC<Props> = ({
  systemDefaultFields,
  systemDefaultPresets,
  selectedColumns,
}) => {
  const dispatchTableApi = useTableGridApiDispatch();
  const { presetColumns, onPresetColumnsChange } = useColumnPresetState();

  const activatePreset = (rows: string[]) => {
    dispatchTableApi({ type: TableGridApiAction.ResetSelectedRows });
    dispatchTableApi({
      type: TableGridApiAction.AddSelectedRows,
      payload: rows,
    });
  };

  return (
    <ColumnPresets
      systemDefaultFields={systemDefaultFields}
      systemDefaultPresets={systemDefaultPresets}
      selectedColumns={selectedColumns}
      presetColumns={presetColumns}
      onActivatePreset={activatePreset}
      onSaveSelectedAsPresetColumns={() => onPresetColumnsChange(selectedColumns)}
    />
  );
};

export default TableGridColumnPresetsToolbar;
